import {API_ROOT_URL} from 'envs/_current/config'
import {schema} from 'normalizr'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

// ===================================== Curriculum =====================================
export const curriculumSchema = new schema.Entity(
    'curricula',
    {},
    {
        idAttribute: 'idname',
    }
)

export const curriculumSubjectSchema = new schema.Entity(
    'curriculum_subjects',
    {},
    {
        idAttribute: 'id',
    }
)

// PUBLIC
export const curriculum_getById_Api = {
    name: 'curriculum_getById_Api',
    backend: `Route::get('courses/curriculum/{id}/get', 'CurriculumController@getCurriculumById');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum/:id/get',
    method: 'GET',
    schema: curriculumSchema,
    transform: createTransform(curriculumSchema, 'data'),
}

export const curriculum_getByOwner_Api = {
    name: 'curriculum_getByOwner_Api',
    backend: `Route::get('courses/curriculum/{type}/{id}/gets', 'CurriculumController@getCurriculaByOwner');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum/:type/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'status'],
    schema: curriculumSchema,
    transform: createListTransform(curriculumSchema),
}

export const curriculum_getSubjects_Api = {
    name: 'curriculum_getSubjects_Api',
    backend: `Route::get('courses/curriculum/{id}/curriculum-subject/gets', 'CurriculumController@getCurriculumSubjects');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum/:id/curriculum-subject/gets',
    method: 'GET',
    schema: curriculumSubjectSchema,
    transform: createListTransform(curriculumSubjectSchema),
}

// AUTH
export const curriculum_create_Api = {
    name: 'curriculum_create_Api',
    backend: `Route::post('courses/{type}/{id}/curriculum/create', 'CurriculumController@createCurriculum');`,
    root: API_ROOT_URL,
    path: '/courses/:type/:id/curriculum/create',
    method: 'POST',
    schema: curriculumSchema,
    transform: createTransform(curriculumSchema, 'data'),
}

export const curriculum_edit_Api = {
    name: 'curriculum_edit_Api',
    backend: `Route::post('courses/curriculum/{id}/edit', 'CurriculumController@editCurriculum');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum/:id/edit',
    method: 'POST',
    schema: curriculumSchema,
    transform: createTransform(curriculumSchema, 'data'),
}

export const curriculum_delete_Api = {
    name: 'curriculum_delete_Api',
    backend: `Route::post('courses/curriculum/{id}/delete', 'CurriculumController@deleteCurriculum');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum/:id/delete',
    method: 'POST',
    schema: curriculumSchema,
    transform: createTransform(curriculumSchema, 'data'),
}

export const curriculum_linkSubject_Api = {
    name: 'curriculum_linkSubject_Api',
    backend: `Route::post('courses/curriculum/{curriculum_id}/subject/{subject_id}/link', 'CurriculumController@linkSubjectToCurriculum');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum/:curriculum_id/subject/:subject_id/link',
    method: 'POST',
    schema: curriculumSubjectSchema,
    transform: createTransform(curriculumSubjectSchema, 'data'),
}

export const curriculum_unlinkSubject_Api = {
    name: 'curriculum_unlinkSubject_Api',
    backend: `Route::post('courses/curriculum-subject/{id}/un-link', 'CurriculumController@unlinkSubjectFromCurriculum');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum-subject/:id/un-link',
    method: 'POST',
    schema: curriculumSubjectSchema,
    transform: createTransform(curriculumSubjectSchema, 'data'),
}

export const curriculum_editSubjectParam_Api = {
    name: 'curriculum_editSubjectParam_Api',
    backend: `Route::post('courses/curriculum-subject/{id}/edit', 'CurriculumController@editSubjectParamInCurriculum');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum-subject/:id/edit',
    method: 'POST',
    schema: curriculumSubjectSchema,
    transform: createTransform(curriculumSubjectSchema, 'data'),
}

export const curriculum_createCourseFrom_Api = {
    name: 'curriculum_createCourseFrom_Api',
    backend: `Route::post('courses/curriculum/{id}/course/create-from', 'CurriculumController@createCourseFromCurriculum');`,
    root: API_ROOT_URL,
    path: '/courses/curriculum/:id/course/create-from',
    method: 'POST',
    schema: curriculumSchema,
    transform: createTransform(curriculumSchema, 'data'),
}
